export default __webpack_public_path__ + "static/15_31-6cef1ea502ec6a7d70b5d0789f664902.png";